<template>
  <hm-content title="">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      class="qrcord"
    >
      <el-form-item label="场景名称" prop="applicationScenario">
        <el-input
          size="small"
          clearable
          class="mr10 ipt"
          maxlength="18"
          v-model.trim="ruleForm.applicationScenario"
          placeholder="请输入场景名称"
        ></el-input>
        <!-- <div class="form-item-tip">规则名称最多18个字</div> -->
      </el-form-item>
      <el-form-item label="功能选择" prop="scanFunction">
        <el-select
          v-model="ruleForm.scanFunction"
          placeholder="请选择功能"
          size="small"
          class="mr10"
          @change="scanFunctionChange"
        >
          <el-option label="优惠券核销" value="coupon"></el-option>
          <el-option label="预约活动核销" value="subscribeActivity"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="优惠券类型"
        prop="couponMode"
        v-if="ruleForm.scanFunction === 'coupon'"
      >
        <el-radio-group v-model="ruleForm.couponMode" size="small">
          <el-radio label="all">全部优惠券</el-radio>
          <el-radio label="appoint">指定优惠券</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        prop="ids"
        v-if="
          ruleForm.scanFunction === 'subscribeActivity' ||
          (ruleForm.scanFunction === 'coupon' &&
            ruleForm.couponMode === 'appoint')
        "
      >
        <div class="daogou-bder">
          <coupon-or-sub-transfer
            ref="beltTransfer"
            showAttribute
            :beltTypes="beltTypes"
            :queryType="queryType"
          ></coupon-or-sub-transfer>
        </div>
      </el-form-item>
    </el-form>
    <div class="btn-wrapper flex flex-center mt20">
      <el-button size="small" type="primary" @click="submitRuleForm('ruleForm')"
        >保存</el-button
      >
    </div>
  </hm-content>
</template>

<script>
import couponOrSubTransfer from "@/components/couponOrSubTransfer";
export default {
  components: {
    couponOrSubTransfer
  },
  data() {
    const patternFunc = (rule, val, callback) => {
      if (this.ruleForm.scanFunction === "subscribeActivity") {
        if (this.$refs.beltTransfer.masterId === "") {
          return callback(new Error("请选择预约活动"));
        }
      } else if (
        this.ruleForm.scanFunction === "coupon" &&
        this.ruleForm.couponMode === "appoint"
      ) {
        if (this.$refs.beltTransfer.rightData.length === 0) {
          return callback(new Error("请选择类型"));
        }
      }

      callback();
    };
    return {
      beltTypes: "coupon",
      queryType: false,
      ruleForm: {
        applicationScenario: "",
        scanFunction: "",
        couponMode: "all",
        ids: []
      },
      rules: {
        applicationScenario: {
          required: true,
          message: "请输入场景名称",
          trigger: "change"
        },
        scanFunction: {
          required: true,
          message: "请选择功能",
          trigger: "change"
        },
        couponMode: [
          {
            required: true,
            message: "请选择优惠券类型",
            trigger: "change"
          }
        ],
        ids: {
          required: true,
          validator: patternFunc,
          trigger: "change"
        }
      }
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    scanFunctionChange(val) {
      if (val === "coupon") {
        this.beltTypes = "coupon";
      } else if (val === "subscribeActivity") {
        this.beltTypes = "promotion";
      }
      if (this.$refs.beltTransfer) {
        this.$refs.beltTransfer.rightData = [];
      }
    },
    submitRuleForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          if (params.scanFunction === "coupon") {
            if (params.couponMode === "appoint") {
              let couponRuleIds = this.$refs.beltTransfer.rightData.map(
                o => o.ruleId
              );
              params.couponRuleIds = couponRuleIds;
            }
          } else {
            params.masterId = this.$refs.beltTransfer.masterId;
          }

          this.$store.dispatch("saveStoreMiniprogramScan", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss">
.qrcord {
  .el-pagination {
    .el-pagination__editor {
      width: 50px;
    }
  }
}
</style>
<style lang='scss' scoped>
</style>
